<template>
  <div :class="$style.container">
    <div :class="$style.paper">
      <div :class="$style.header">
        <button :class="$style.backButton" @click="goBack" title="뒤로가기">
          ←
        </button>
        <h2 :class="$style.title">내 정보</h2>
        <div :class="$style.spacer"></div>
      </div>

      <div :class="$style.listSection">
        <button :class="$style.listItem" @click="goEditInfo">
          <span>닉네임 변경</span>
          <!-- <span :class="$style.chevron">›</span> -->
        </button>
        <!-- <button :class="$style.listItem" @click="goAddressManage">
          <span>배송지 관리</span>
          <span :class="$style.chevron">›</span>
        </button>
        <button :class="$style.listItem" @click="goNotificationSetting">
          <span>알림 설정</span>
          <span :class="$style.chevron">›</span>
        </button> -->
        <button :class="[$style.listItem, $style.listItemX]" @click="connectX" :disabled="xConnecting">
          <span :class="$style.xConnectLabel">
            <img src="@/assets/images/xlogowhite.png" alt="X" :class="$style.xLogoInList" />
            <span>{{ xConnecting ? '연동 중...' : '계정 연동' }}</span>
          </span>
        </button>
      </div>

      <button :class="$style.logoutItem" @click="logout">
        로그아웃
      </button>
      <button type="button" :class="$style.withdrawItem" @click="openWithdrawInquiry" title="카카오톡으로 회원 탈퇴 요청">
        회원 탈퇴 요청
      </button>
    </div>
  </div>
</template>

<script>
import { useUserStore } from "@/store/user";
import { trackMenuClick } from "@/utils/statistics";

const KAKAO_INQUIRY_CHANNEL_URL = "http://pf.kakao.com/_sIxgZX";

export default {
  name: "MyInfo",
  data() {
    return {
      userStore: useUserStore(),
      xConnecting: false,
    };
  },
  mounted() {
    if (!this.userStore.isLogin) {
      this.$alert("로그인이 필요합니다.");
      this.$router.push("/");
    }
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    goEditInfo() {
      trackMenuClick("editProfile");
      this.userStore.nicknamePopup = true;
    },
    goAddressManage() {
      this.$alert("배송지 관리는 준비 중입니다.");
    },
    goNotificationSetting() {
      trackMenuClick("notifications");
      this.$router.push("/notifications");
    },
    async connectX() {
      if (!process.env.VUE_APP_X_CLIENT_ID) {
        this.$alert("X 연동이 설정되지 않았습니다.");
        return;
      }
      try {
        this.xConnecting = true;
        document.cookie = "x_state=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        document.cookie = "x_auth_type=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        document.cookie = "x_code_verifier=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        await new Promise((resolve) => setTimeout(resolve, 1000));
        const codeVerifier = this.generateCodeVerifier();
        const codeChallenge = await this.generateCodeChallenge(codeVerifier);
        const state = this.generateRandomString(32);
        const expireTime = new Date(Date.now() + 30 * 60 * 1000);
        document.cookie = `x_code_verifier=${encodeURIComponent(codeVerifier)}; expires=${expireTime.toUTCString()}; path=/; SameSite=Lax`;
        document.cookie = `x_state=${encodeURIComponent(state)}; expires=${expireTime.toUTCString()}; path=/; SameSite=Lax`;
        document.cookie = `x_auth_type=profile; expires=${expireTime.toUTCString()}; path=/; SameSite=Lax`;
        await new Promise((resolve) => setTimeout(resolve, 100));
        if (!this.getCookie("x_code_verifier") || !this.getCookie("x_state") || !this.getCookie("x_auth_type")) {
          throw new Error("쿠키 저장에 실패했습니다.");
        }
        const params = new URLSearchParams({
          response_type: "code",
          client_id: process.env.VUE_APP_X_CLIENT_ID,
          redirect_uri: `${window.location.origin}/x-callback`,
          scope: "tweet.read users.read offline.access",
          state,
          code_challenge: codeChallenge,
          code_challenge_method: "S256",
        });
        const authUrl = `https://x.com/i/oauth2/authorize?${params.toString()}`;
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        if (isMobile) {
          window.location.href = authUrl;
        } else {
          const popup = window.open(authUrl, "x_auth", "width=500,height=600,scrollbars=yes,resizable=yes");
          if (!popup) {
            this.$alert("팝업이 차단되었습니다. 브라우저 설정에서 팝업을 허용해주세요.");
            this.xConnecting = false;
            return;
          }
          const messageHandler = (event) => {
            if (event.origin !== window.location.origin) return;
            if (event.data.type === "X_CONNECT_SUCCESS") {
              this.xConnecting = false;
              this.$alert(event.data.message).then(() => window.location.reload());
              window.removeEventListener("message", messageHandler);
              document.cookie = "x_auth_type=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            } else if (event.data.type === "X_CONNECT_ERROR") {
              this.xConnecting = false;
              this.$alert(`X 연동 실패: ${event.data.message}`);
              window.removeEventListener("message", messageHandler);
              document.cookie = "x_auth_type=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            }
          };
          window.addEventListener("message", messageHandler);
          const checkClosed = setInterval(() => {
            if (popup.closed) {
              clearInterval(checkClosed);
              setTimeout(() => {
                if (this.xConnecting) {
                  this.xConnecting = false;
                  this.$alert("X 연동이 취소되었습니다.");
                  window.removeEventListener("message", messageHandler);
                  document.cookie = "x_auth_type=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                }
              }, 1000);
            }
          }, 1000);
        }
      } catch (error) {
        this.$alert("X 연동 중 오류가 발생했습니다.");
        this.xConnecting = false;
      }
    },
    generateCodeVerifier() {
      const array = new Uint8Array(32);
      crypto.getRandomValues(array);
      return this.base64URLEncode(array);
    },
    async generateCodeChallenge(codeVerifier) {
      const encoder = new TextEncoder();
      const data = encoder.encode(codeVerifier);
      const digest = await crypto.subtle.digest("SHA-256", data);
      return this.base64URLEncode(new Uint8Array(digest));
    },
    base64URLEncode(array) {
      return btoa(String.fromCharCode.apply(null, array))
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=/g, "");
    },
    generateRandomString(length) {
      const charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
      let result = "";
      const values = crypto.getRandomValues(new Uint8Array(length));
      values.forEach((value) => { result += charset[value % charset.length]; });
      return result;
    },
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return decodeURIComponent(parts.pop().split(";").shift());
      return null;
    },
    logout() {
      trackMenuClick("logout");
      this.userStore.logOut();
      this.$router.push("/");
    },
    openWithdrawInquiry() {
      trackMenuClick("withdrawInquiryKakao");
      window.open(KAKAO_INQUIRY_CHANNEL_URL, "_blank", "noopener,noreferrer");
    },
  },
};
</script>

<style module>
.container {
  width: 90%;
  min-height: calc(100vh - 80px);
  margin: 0 auto;
}

.paper {
  background: #eee;
  border-radius: 12px;
  overflow: hidden;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  border-bottom: 1px solid #e9e9e9;
  background-color: white;
  padding: 0 12px;
}

.backButton {
  background: transparent;
  border: none;
  color: #444;
  font-size: 18px;
  cursor: pointer;
  width: 24px;
  height: 24px;
}

.title {
  margin: 0;
  font-size: 19px;
  font-weight: 700;
  color: #111;
  font-family: "NanumSquareRoundEB", sans-serif;
  letter-spacing: -0.3px;
}

.spacer {
  width: 24px;
}

.listSection {
  background: #fff;
}

.listItem {
  width: 100%;
  background: #fff;
  border: none;
  border-bottom: 1px solid #efefef;
  border-radius: 0;
  padding: 15px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 15px;
  color: #3f3f3f;
  text-align: left;
  cursor: pointer;
  font-family: "NanumSquareRoundR", sans-serif;
}

.listItem:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.xConnectLabel {
  display: flex;
  align-items: center;
  gap: 8px;
}

.xLogoInList {
  width: 15px;
  height: 15px;
  display: block;
}

.listItem:active {
  background: #fafafa;
}

.listItemX {
  background: #111;
  color: #fff;
}

.listItemX:active {
  background: #2a2a2a;
}

.listItemX:disabled {
  background: #555;
  opacity: 1;
  cursor: not-allowed;
}

.chevron {
  color: #c0c0c0;
  font-size: 22px;
  line-height: 1;
  margin-left: 6px;
}

.logoutItem {
  width: 100%;
  margin-top: 10px;
  background: #fff;
  border: none;
  border-radius: 0;
  padding: 15px 16px;
  text-align: left;
  font-size: 15px;
  color: #9a9a9a;
  cursor: pointer;
  font-family: "NanumSquareRoundR", sans-serif;
}

.logoutItem:active {
  background: #fafafa;
}

.withdrawItem {
  width: 100%;
  margin-top: 4px;
  background: transparent;
  border: none;
  border-radius: 0;
  padding: 12px 16px 18px;
  text-align: left;
  font-size: 13px;
  color: #c92a2a;
  cursor: pointer;
  font-family: "NanumSquareRoundR", sans-serif;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.withdrawItem:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.withdrawItem:not(:disabled):active {
  color: #a61e1e;
}

@media screen and (max-width: 480px) {
  .container {
    width: 100%;
  }

  .paper {
    border-radius: 0;
  }

  .listItem {
    padding: 14px 14px;
    font-size: 14px;
  }

  .chevron {
    font-size: 20px;
  }

  .logoutItem {
    font-size: 14px;
    padding: 14px 14px;
  }

  .withdrawItem {
    font-size: 12px;
    padding: 10px 14px 16px;
  }
}
</style>
